import React from "react";
import { Box, Typography } from "@mui/material";
import DataSourceContainer from "../components/DataSourceContainer";
import theme from "Theme/AppTheme";
import { observer } from "mobx-react";
import AddButton from "../components/AddButton";
import {
    KeyFieldType,
    SelectedTargetFields,
    TargetFieldOptions,
} from "../types";
import { fieldContainerStyles } from "../helpers/componentUtils";
import KeyField from "./KeyField";

type KeyFieldsProps = {
    keyFields: KeyFieldType[];
    sourceFieldOptions: { label: string; value: string }[];
    sourcesWithCoreTargets: string[];
    getUpdatedTargetFields: () => {
        targetFieldOptions: TargetFieldOptions;
        selectedTargetFields: SelectedTargetFields;
    };
    addKeyField: () => void;
    updateKeyField: (
        id: string,
        key: string,
        value: string,
        targetFieldId?: string,
    ) => void;
    removeKeyField: (id: string) => void;
};

const KeyFields: React.FC<KeyFieldsProps> = observer(
    ({
        keyFields,
        sourceFieldOptions,
        sourcesWithCoreTargets,
        getUpdatedTargetFields,
        addKeyField,
        updateKeyField,
        removeKeyField,
    }) => {
        return (
            <DataSourceContainer
                heading="Key Fields"
                subHeading="Select the field in the new file that matches an existing field in our system. This mapping helps us link incoming metadata to the corresponding conversations"
            >
                <Box
                    sx={{
                        background: theme.palette.gray[100],
                        borderRadius: 2,
                        padding: 2,
                    }}
                >
                    {!!keyFields.length && (
                        <>
                            <Box
                                sx={{
                                    display: "flex",
                                    padding: theme.spacing(1),
                                    gap: 2,
                                }}
                            >
                                <Typography
                                    sx={{
                                        flex: 16,
                                        fontWeight: 600,
                                        fontSize: 14,
                                    }}
                                >
                                    Select Key Field for Source:
                                </Typography>
                                <Typography
                                    sx={{
                                        flex: 16,
                                        fontWeight: 600,
                                        fontSize: 14,
                                        paddingRight: 1,
                                    }}
                                >
                                    Select Key Field for Target:
                                </Typography>
                            </Box>
                            <Box sx={{ ...fieldContainerStyles }}>
                                {keyFields.map((field) => (
                                    <KeyField
                                        key={field.id}
                                        {...field}
                                        sourceFieldOptions={sourceFieldOptions}
                                        sourcesWithCoreTargets={
                                            sourcesWithCoreTargets
                                        }
                                        getUpdatedTargetFields={
                                            getUpdatedTargetFields
                                        }
                                        updateKeyField={updateKeyField}
                                        removeKeyField={() =>
                                            removeKeyField(field.id)
                                        }
                                    />
                                ))}
                            </Box>
                        </>
                    )}
                    <AddButton onClick={addKeyField} sx={{ marginTop: 2 }}>
                        Add Field
                    </AddButton>
                </Box>
            </DataSourceContainer>
        );
    },
);

export default KeyFields;
